
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import CheckoutForm from './components/CheckoutForm';
import OrderSummary from './components/OrderSummary';
import OrderConfirmation from './components/OrderConfirmation';

export default function CheckoutPage() {
  const { cartItems, cartTotal } = useCart();
  const navigate = useNavigate();
  const [orderPlaced, setOrderPlaced] = useState(false);
  const [orderRef, setOrderRef] = useState('');

  const handleOrderSuccess = (ref: string) => {
    setOrderRef(ref);
    setOrderPlaced(true);
  };

  // If the order has been placed, show the confirmation screen.
  if (orderPlaced) {
    return <OrderConfirmation orderRef={orderRef} total={cartTotal} />;
  }

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      {/* Top Bar */}
      <header className="bg-[#111] border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-3 cursor-pointer"
          >
            <img
              src="https://static.readdy.ai/image/4abb71d54c7d60621cfc0b2fab4f7970/3b1e60a7c97fafd8931cbea82c7dfd99.png"
              alt="Nightmare Logo"
              className="w-16 h-16 object-contain"
            />
          </button>

          {/* Steps */}
          <div className="hidden md:flex items-center gap-3 text-sm font-semibold uppercase tracking-widest">
            <button
              onClick={() => navigate('/#merchandise')}
              className="text-gray-500 hover:text-gray-300 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-shopping-bag-line mr-1"></i> Cart
            </button>
            <i className="ri-arrow-right-s-line text-gray-700"></i>
            <span className="text-[#8B0000]">Checkout</span>
            <i className="ri-arrow-right-s-line text-gray-700"></i>
            <span className="text-gray-600">Confirmation</span>
          </div>

          <button
            onClick={() => navigate('/')}
            className="text-gray-500 hover:text-white transition-colors text-sm cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line mr-1"></i> Continue Shopping
          </button>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 py-12">
        {cartItems.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-32 text-center">
            <div className="w-20 h-20 flex items-center justify-center mb-6">
              <i className="ri-shopping-bag-line text-6xl text-gray-700"></i>
            </div>
            <h2 className="text-white text-2xl font-bold mb-3">Your cart is empty</h2>
            <p className="text-gray-500 mb-8">
              Add some Nightmare gear before checking out.
            </p>
            <button
              onClick={() => navigate('/')}
              className="bg-[#8B0000] hover:bg-[#6B0000] text-white font-bold px-10 py-4 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              SHOP NOW
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            {/* Left: Form */}
            <div className="lg:col-span-7">
              <CheckoutForm onSuccess={handleOrderSuccess} />
            </div>
            {/* Right: Summary */}
            <div className="lg:col-span-5">
              <OrderSummary />
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
